import { generatePath, useHistory } from 'react-router-dom';
import queryString from 'query-string';
import classNames from 'classnames';
import { t, jt } from 'ttag';

import CardIcon from '@svg/card.svg';
import ParcelIcon from '@svg/parcel.svg';
import CashIcon from '@svg/cash.svg';
import ReturnIcon from '@svg/return.svg';
import { safePaymentLanding } from '@urls';
import { Modal } from '@ui/Modal';
import { Button } from '@ui/Button';
import { Title } from '@ui/Title';

import s from './SafePaymentBenefitsModal.sss';

const linebreak = <br key="0" />;

const BENEFITS = [
  {
    title: () => t`Ви оплачуєте замовлення картою`,
    description: () => t`Ми утримуємо гроші та гарантуємо їх збереження`,
    icon: CardIcon,
  },
  {
    title: () => t`Забираєте замовлення`,
    description: () => t`Якщо не отримаєте посилку або товар не підійде,
    то гроші повернемо вам на картку (за вирахуванням вартості доставки в одну сторону)`,
    icon: ParcelIcon,
  },
  {
    title: () => t`Продавець отримує гроші`,
    description: () => t`Коли ви заберете товар поштою, ми перерахуємо гроші за замовлення продавцю.
    Все просто та безпечно`,
    icon: CashIcon,
  },
  {
    title: () => t`Ви можете повернути новий товар впродовж 14 днів`,
    description: () => t`Якщо продавець відмовиться від повернення, 
    ви отримаєте компенсацію в сумі до 1000 грн (вийняток: товари, які не підлягають поверненню згідно законодавства). 
    Щоб отримати компенсацію, зверніться у Відділ турботи.`,
    icon: ReturnIcon,
  },
];

interface Props {
  isOpen: boolean,
  className?: string,
  onClose: () => void,
}

export const SafePaymentBenefitsModal: React.FC<Props> = ({
  isOpen,
  className,
  onClose,
}) => {
  const history = useHistory();
  const landingPath = generatePath(safePaymentLanding, { role: 'for-buyer' });

  return (
    (
      <Modal
        className={classNames(s.root, className)}
        isOpen={isOpen}
        withClose={true}
        onRequestClose={onClose}
      >
        <Title
          className={s.title}
          type="h3"
          bold={false}
        >
          {jt`Купуйте цей товар з ${linebreak}Безпечною оплатою`}
        </Title>
        <ul className={s.list}>
          {BENEFITS.map(({ title, description, icon: Icon }, i) => (
            <li
              key={i}
              className={s.item}
            >
              <Icon
                className={s.itemIcon}
                width="24"
                height="24"
              />
              <div className={s.info}>
                <p className={s.itemTitle}>
                  {title()}
                </p>
                <p>
                  {description()}
                </p>
              </div>
            </li>
          ))}
        </ul>
        <div className={s.buttons}>
          <Button
            className={s.button}
            theme="secondary"
            href={history.createHref({
              pathname: landingPath,
              search: queryString.stringify({
                next: history.location.pathname,
              }),
            })}
          >
            {t`Читати докладніше`}
          </Button>
          <Button
            className={s.button}
            onClick={onClose}
          >
            {t`Добре`}
          </Button>
        </div>
      </Modal>
    )
  );
};
